import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Estomac = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.31 82.2">
  <G fill={color}>
    <Path d="M74.08,19.94c-4.18-4.51-9.45-7.07-14.61-7.11-3.43-2.45-4.93-8.09-5.23-10.18-.21-1.52-1.51-2.65-3.05-2.65h-10.97c-1.7,0-3.08,1.38-3.08,3.08,0,7.59,4.13,14.74,7.26,18.56-.9,1.86-1.44,4.21-2,6.64-.57,2.47-1.22,5.27-2.11,6.63l-.19.29c-2.29,3.5-5.75,8.8-9.9,10.22-3.06,1.04-5.95,3.13-8.5,4.97-2.1,1.52-4.28,3.08-5.64,3.36-.32.07-.68.04-1.29-.01-1.57-.14-3.96-.34-7.22,1.82C1.81,59.34-.67,66.4.16,76.53c.13,1.6,1.47,2.83,3.07,2.83h10.03c.84,0,1.64-.34,2.22-.95.58-.6.89-1.42.85-2.26-.12-2.83.31-4.05.53-4.47.38.11,1.27.49,2.79,1.84,6.49,5.75,14.62,8.69,23.84,8.69,2.66,0,5.41-.24,8.23-.74,7.94-1.39,26.77-7.39,30.22-33.13,1.48-11.06-1.38-21.41-7.86-28.4Z"/>
  </G>
</Svg>
);
};

export default Estomac;
